import React, { useMemo } from 'react';

import usePage from '@dashboard/hooks/usePage';
import { PaymentsChargesList } from '@dashboard/scenes/PaymentsCharges';

const DEFAULT_SORT = { createdAt: '-1' };

function RecentPayments() {
  const { page } = usePage();

  const filter = useMemo(
    () => ({
      page: page._id,
      livemode: true,
    }),
    [page._id],
  );

  return (
    <div className="overflow-auto mb-20">
      <PaymentsChargesList
        pageType={page.type}
        sort={DEFAULT_SORT}
        filter={filter}
        options={{
          hidePaymentLink: true,
        }}
        infinite={false}
      />
    </div>
  );
}

export default RecentPayments;
